module.exports = __webpack_public_path__ + "e114178d259b2c93b3159eaf36efb271.pdf";